import React, { useEffect } from "react";
import { Grid2 } from "@mui/material";
import styles from "./BillingInfo.module.scss";
import CustomInput from "../../../../../../GlobalComponents/CustomInput/CustomInput";
// Icons
import { ReactComponent as Usa } from "../../../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../../../GlobalAssets/svg/IndianSvg.svg";
import { countryStateData } from "../../../../../../Utils/countryStateData";

function BillingInfo(props) {
  const {
    selectedOrg,
    userDetails,
    isChecked,
    // setIsChecked,
    selectedCountry,
    setSelectedState,
    ind,
  } = props;

  const getCountryKey = () => (selectedCountry === "USA" ? "USA" : "India");

  useEffect(() => {
    const countryKey = getCountryKey();
    const defaultState =
      selectedOrg?.state ||
      userDetails?.state ||
      countryStateData[countryKey][0]?.value;

    setSelectedState(defaultState);
  }, [selectedCountry, selectedOrg, userDetails]);

  // const handleCheckboxChange = () => {
  //   setIsChecked(!isChecked);
  // };

  return (
    <Grid2 className={styles.billingInfoContainer}>
      <Grid2 className={styles.flexbox}>
        <Grid2 className={styles.width}>
          <CustomInput
            title="Address"
            placeholder="Enter Address"
            value={ind === "-1" ? userDetails?.address : selectedOrg?.address}
            disabled={true}
          />
        </Grid2>
        <Grid2 className={styles.width1}>
          {/* <Dropdown
            title="Country of residence"
            placeholder="Select Your Country"
            options={countryOptions}
            value={selectedCountry}
            optlabel="label"
            optvalue="value"
            onSelect={(val) => {
              setSelectedCountry(val);
              setSelectedState("");
            }}
            disabled={true}
          /> */}
          <CustomInput
            title="Country of residence"
            placeholder="Select Country"
            value={ind === "-1" ? userDetails?.country : selectedOrg?.country}
            frontEndorment={
              selectedOrg?.country === "India" ? (
                <Indian />
              ) : selectedOrg?.country === "USA" ||
                userDetails?.country === "USA" ? (
                <Usa />
              ) : (
                <Indian />
              )
            }
            disabled={true}
          />
        </Grid2>
      </Grid2>
      <Grid2 className={styles.flexbox}>
        <Grid2 className={styles.width1}>
          {/* <Dropdown
            title="State"
            placeholder="Select Your State"
            options={countryStateData[getCountryKey()]}
            value={selectedState}
            optlabel="label"
            optvalue="value"
            onSelect={(val) => {
              setSelectedState(val);
            }}
            disabled={true}
          /> */}
          <CustomInput
            title="State"
            placeholder="Enter State"
            value={ind === "-1" ? userDetails?.state : selectedOrg?.state}
            disabled={true}
          />
        </Grid2>
        <Grid2 className={styles.width1}>
          <CustomInput
            title="City"
            placeholder="Enter City"
            value={ind === "-1" ? userDetails?.city : selectedOrg?.city}
            disabled={true}
          />
        </Grid2>
        <Grid2 className={styles.width1}>
          <CustomInput
            title="ZIP Code"
            placeholder="Enter ZIP Code"
            value={ind === "-1" ? userDetails?.zipCode : selectedOrg?.zipCode}
            disabled={true}
          />
        </Grid2>
      </Grid2>
      {/* <Grid2 className={styles.flexCheckBox}>
        {isChecked ? (
          <CheckBoxIcon
            onClick={handleCheckboxChange}
            className={styles.checkBox}
          />
        ) : (
          <CheckBoxOutlineBlankIcon
            onClick={handleCheckboxChange}
            className={styles.checkBox}
          />
        )}
        <Grid2 className={styles.companylabel}>Add company detils</Grid2>
      </Grid2> */}
      {isChecked && (
        <Grid2 className={styles.flexbox}>
          <CustomInput
            title="Company Name"
            placeholder="Enter Your Company Name"
          />
          <CustomInput title="VAT/Tax ID" placeholder="Enter Your VAT/Tax Id" />
        </Grid2>
      )}
    </Grid2>
  );
}

export default BillingInfo;
